import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Header from "../components/header/header";
import { Buffer } from "buffer";
import MessageDialog from "../components/dialogue/messageDialogue";
import BoardDialog from "../components/dialogue/messageDialogue";
import Input from "../components/input/input";
import Button from "../components/button/button";
import Profile from "../components/profile/profileInClientView";
import Snackbar from "@mui/material/Snackbar";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import IconButton from "@material-ui/core/IconButton";

// datapicker imports
import DateTimePicker from "@mui/lab/DateTimePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import Stack from "@mui/material/Stack";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";

// Import form
import { useForm } from "react-hook-form";

// Import supabase configuration
import supabase from "../config/supabase";

function Client() {
  const navigate = useNavigate();

  const [profiles, setProfiles] = useState([]);
  const [clientProfiles, setClientProfiles] = useState([]);
  const [profilesWithStatus, setProfilesWithStatus] = useState([]);
  const [boardId, setBoardId] = useState("");
  const [message, setMessage] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [profileId, setProfileId] = useState("");
  const [statusValue, setValue] = useState("New");
  const [showNotification, setShowNotification] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [showNewModal, setshowNewModal] = useState(false);
  const [tabValue, setTabValue] = useState("1");
  const [displayMessage, setDisplayMessage] = useState("");
  const [dateTime, setDateTime] = useState([]);
  const [dateButton, setDateButton] = useState(false);
  const [justView, setJustView] = useState(true);
  const [showSignup, setShowSignup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [userToken, setUserToken] = useState("");

  // data time picker
  const [dateTimePicker, setDateTimePicker] = useState("");

  //This hook using for form-validation
  const { handleSubmit } = useForm();

  useEffect(() => {
    document.title = "Client View";

    var url = new URL(window.location.href);
    var url_with_token = window.location.href;
    var board_id = url.searchParams.get("id").split("/")[0];
    var boardId = Buffer.from(board_id || "", "base64").toString("utf-8");
    setBoardId(boardId);
    setUserToken(url_with_token);

    var token = url.searchParams.get("id").split("/")[1];
    // For email based clients
    if (token) {
      setJustView(false);
      getBoardProfiles(boardId, url_with_token);
    } else {
      getBoardProfiles(boardId, "");
    }

    var loggedIn = localStorage.getItem("loggedIn") || "";
    loggedIn && setShowSignup(true);
  }, []);

  useEffect(() => {
    if (dateTime.length >= 3) {
      setDateButton(true);
    } else {
      setDateButton(false);
    }
  }, [dateTime]);

  useEffect(async () => {
    if (boardId && userToken) {
      const { data, error } = await supabase
        .from("board_clients_invitation")
        .select("*")
        .match({ board: boardId, url_with_token: userToken });

      setClientProfiles(data[0].profiles);
    }
  }, [statusValue]);

  // dateTime added using
  const addDateTime = () => {
    if (dateTimePicker === "" || dateTimePicker === undefined) {
      setErrorMessage("Please select date and time");
    } else {
      setDateTime([...dateTime, dateTimePicker]);
      setDateTimePicker("");
    }
  };

  // date time delete
  const handleDateTimeDelete = (index) => {
    const removeItem = dateTime.filter((item, i) => i !== index);
    setDateTime(removeItem);
  };

  // date time form submission
  const handleDayTimeSubmit = () => {
    if (dateTime.length <= 0) {
      setErrorMessage("Please add date time");
    } else {
      updateProfileStatus("accepted");
    }
  };
  // sending datetime to db

  const getBoardProfiles = async (id, token) => {
    var client = [];

    if (token) {
      var { data, error } = await supabase
        .from("board_clients_invitation")
        .select("*")
        .match({ board: id, url_with_token: token });

      if (data && data.length) {
        client = data;
      }
    } else {
      var { data, error } = await supabase
        .from("board_profiles")
        .select("*")
        .match({ board: id });

      if (data && data.length) {
        client = data;
      }
    }

    if (client.length) {
      client[0].profiles && setClientProfiles(client[0].profiles);
    }

    var profiles =
      client.length && client[0].profiles
        ? await getProfileDetails(client[0].profiles)
        : [];
    setProfiles(profiles);
    setShowLoader(false);
    setShowNotification(true);
    profiles.length > 0
      ? setDisplayMessage("Profiles have been loaded successfully.")
      : setDisplayMessage("No profile found");
    setTimeout(function () {
      setShowNotification(false);
    }, 2000);
  };

  const getProfileDetails = async (ids) => {
    var all_profiles = [];
    for (var i = 0; i < ids.length; i++) {
      const { data, error } = await supabase
        .from("all_profiles")
        .select("*")
        .match({ id: ids[i].id });
      var profile = { ...data[0], status: ids[i].status };
      all_profiles.push(profile);
    }
    return all_profiles;
  };

  const updateProfileStatus = async () => {
    setshowModal(false);
    setshowNewModal(false);
    setShowLoader(true);
    var all_profiles = [...clientProfiles];
    all_profiles = all_profiles.map((p) =>
      p.id == profileId
        ? { ...p, message: message, status: statusValue, meetingTime: dateTime }
        : p
    );

    const { data, error } = await supabase
      .from("board_clients_invitation")
      .update({ profiles: all_profiles })
      .match({ board: boardId, url_with_token: userToken });

    if (error) {
      setDisplayMessage("Sorry, unable to update status");
    } else {
      setDisplayMessage("Status Updated successfully.");
    }

    var all_profiles = [...profiles];
    all_profiles = all_profiles.map((p) =>
      p.id === profileId ? { ...p, status: statusValue } : p
    );
    // Set profiles
    setProfiles(all_profiles);

    setShowNotification(true);
    setMessage("");
    setProfileId("");
    setValue("New");
    setShowLoader(false);
    setDateTime([]);
    setDateTimePicker("");

    // Hide notification
    setTimeout(function () {
      setShowNotification(false);
    }, 2000);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const toLogin = () => {
    localStorage.setItem("clientUrl", userToken);
    localStorage.setItem("boardId", boardId);
    navigate(`/login`);
  };

  return (
    <div className="w-full min-h-screen h-auto bg-white-2 mb-10">
      <Header current="home" clientView />

      {showLoader && (
        <div className="fixed flex items-center justify-center z-20 w-full h-full top-0">
          {/* Add backdrop */}
          <div className={`absolute opacity-20 bg-black-1 w-full h-full`}></div>
          <div className={`relative `}>
            <img src="/loader.png"  className="rotate"/>
          </div>
        </div>
      )}

      {/* Notification */}
      <Snackbar
        open={showNotification}
        message={displayMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />

      {/* Show modal */}
      <MessageDialog
        title="Please add message here"
        onClick={() => {
          setshowModal(false);
        }}
        show={showModal}
      >
        <form className="" onSubmit={handleSubmit(updateProfileStatus)}>
          {
            <div className="grid grid-cols-12 gap-3 col-span-12">
              {/* Message */}
              <div className={`col-span-12`}>
                {/* Add message */}
                <Input
                  name="status"
                  value={message}
                  placeholder="Please Add Your Comment"
                  onInputChange={(e) => {
                    setMessage(e);
                  }}
                />
              </div>

              {/* Button */}
              <div className="col-span-12 mt-2 flex space-x-2 justify-end">
                <Button type="submit" value="Add" buttonType="secondary-2" />
                <Button
                  type="button"
                  onClick={() => {
                    setshowModal(false);
                    updateProfileStatus();
                  }}
                  value="Cancel"
                  buttonType="cancel"
                />
              </div>
            </div>
          }
        </form>
      </MessageDialog>

      {/* Accepted modal starts here  */}

      <MessageDialog
        title="Add Appointment slots"
        onClick={() => {
          setshowNewModal(false);
        }}
        show={showNewModal}
      >
        <div>
          <p
            style={{
              fontSize: "14px",
              color: "gray",
              marginTop: "-20px",
              marginBottom: "10px",
            }}
          >
            Add Atleast one slot
          </p>
          {dateTime.map((newdateTime, index) => (
            <div className="grid grid-cols-12 gap-3 col-span-12" key={index}>
              <div className="col-span-12">
                <p className="mb-2 mt-2">
                  <span>
                    Slot {index + 1} : {newdateTime}
                  </span>
                  <CloseIcon
                    color="primary"
                    className="float-right cursor-pointer"
                    onClick={() => handleDateTimeDelete(index)}
                  />
                </p>
              </div>
            </div>
          ))}
          <form
            className=""
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            {
              <div className="grid grid-cols-12 gap-3 col-span-12">
                {/* Message */}
                <div className={`col-span-12`}>
                  {/* Date time picker */}
                  <Input
                    name="dateTime"
                    value={dateTimePicker}
                    placeholder="Please Add Your Appointment"
                    onInputChange={(e) => {
                      setDateTimePicker(e);
                      setErrorMessage("");
                    }}
                    addDateTime={addDateTime}
                  />
                </div>
                <div className="col-span-12 mt-2 flex space-x-2 justify-end">
                  <Button
                    type="button"
                    value="Add Your appointment"
                    color="primary"
                    variant="contained"
                    onClick={addDateTime}
                    className={dateButton ? "hidden" : ""}
                  />
                </div>
                <div className="col-span-12 mt-2 flex space-x-2 justify-start">
                  {errorMessage && (
                    <p style={{ color: "red" }}>{errorMessage}</p>
                  )}
                </div>
                {/* Button */}
                <div className="col-span-12 mt-2 flex space-x-2 justify-end">
                  <Button
                    type="button"
                    onClick={handleDayTimeSubmit}
                    value="Add"
                    buttonType="secondary-2"
                  />
                  <Button
                    type="button"
                    onClick={() => {
                      setshowNewModal(false);
                      // updateProfileStatus();
                    }}
                    value="Cancel"
                    buttonType="cancel"
                  />
                </div>
              </div>
            }
          </form>
        </div>
      </MessageDialog>
      {/* Accepted modal ends here */}

      <div className="pt-4 flex justify-between px-5">
        <div className="font-bold text-2xl">Client Board</div>
        {!justView && (
          <div
            className="flex justify-end text-sm hover:text-blue-1 cursor-pointer"
            onClick={() => toLogin()}
          >
            Sign Up or Sign In
          </div>
        )}
      </div>

      <TabContext value={tabValue}>
        <Box
          sx={{ borderBottom: 1, borderColor: "divider", paddingLeft: "10px" }}
        >
          <TabList
            onChange={handleTabChange}
            aria-label="lab API tabs "
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Tab label="All Profiles" value="1" />
            <Tab label="On Hold" value="2" />
            <Tab label="Accepted" value="3" />
            <Tab label="Rejected" value="4" />
          </TabList>
        </Box>

        <TabPanel value="1">
          {" "}
          <div className="col-span-12 grid grid-cols-12 gap-3 px-5 md:px-10 ">
            {profiles.length > 0 &&
              profiles.map((profile, index) => {
                return clientProfiles.find(
                  (c) => c.status === "New" && c.id === profile.id
                ) ? (
                  <div key={index} className="col-span-12 md:col-span-3 pt-10">
                    {" "}
                    <Profile
                      profile={profile}
                      justView={!showSignup}
                      updateProfileStatus={updateProfileStatus}
                      showNewModal={() => {
                        setshowNewModal(true);
                      }}
                      showModal={() => {
                        setshowModal(true);
                      }}
                      setProfileid={(e) => setProfileId(e)}
                      setValue={(e) => setValue(e)}
                      // statusValue={statusValue}
                    />{" "}
                  </div>
                ) : (
                  <div className="hidden" key={index}></div>
                );
              })}
          </div>
        </TabPanel>

        {clientProfiles.length > 0 &&
          !clientProfiles.some((c) => c.status == "New") && (
            <TabPanel value="1">
              {" "}
              <div className="col-span-12 text-xl font-bold md:px-10 -mt-10">
                New Profiles
                <p className="pl-10 font-normal text-sm">No New profile</p>
              </div>
            </TabPanel>
          )}

        <TabPanel value="1">
          {" "}
          <div className="col-span-12 grid grid-cols-12 gap-x-3 px-5 md:px-10">
            {clientProfiles.length > 0 &&
            clientProfiles.find((c) => c.status !== "New") ? (
              <div className="col-span-12 text-xl font-bold">
                Processed profiles
              </div>
            ) : (
              <div className="hidden"></div>
            )}
            {profiles.length > 0 &&
              profiles.map((profile, index) => {
                return clientProfiles.find(
                  (c) => c.status != "New" && c.id == profile.id
                ) ? (
                  <div key={index} className="col-span-12 md:col-span-3">
                    {" "}
                    <Profile
                      profile={profile}
                      justView={!showSignup}
                      updateProfileStatus={updateProfileStatus}
                      showNewModal={() => {
                        setshowNewModal(true);
                      }}
                      showModal={() => {
                        setshowModal(true);
                      }}
                      setProfileid={(e) => setProfileId(e)}
                      setValue={(e) => setValue(e)}
                      // statusValue={statusValue}
                      proccessed={true}
                    />{" "}
                  </div>
                ) : (
                  <div className="hidden" key={index}></div>
                );
              })}
          </div>
        </TabPanel>

        <TabPanel value="2">
          <div className="col-span-12 grid grid-cols-12 gap-3 px-5 md:px-10 pt-10">
            {profiles.length > 0 &&
              profiles.map((profile, index) => {
                return clientProfiles.find(
                  (c) => c.status === "Hold" && c.id === profile.id
                ) ? (
                  <div key={index} className="col-span-12 md:col-span-3">
                    {" "}
                    <Profile
                      profile={profile}
                      justView={!showSignup}
                      updateProfileStatus={updateProfileStatus}
                      showNewModal={() => {
                        setshowNewModal(true);
                      }}
                      showModal={() => {
                        setshowModal(true);
                      }}
                      setProfileid={(e) => setProfileId(e)}
                      setValue={(e) => setValue(e)}
                      proccessed={true}
                    />{" "}
                  </div>
                ) : (
                  <div key={index} className="hidden"></div>
                );
              })}
          </div>
        </TabPanel>

        <TabPanel value="3">
          <div className="col-span-12 grid grid-cols-12 gap-3 px-5 md:px-10 pt-10">
            {profiles.length > 0 &&
              profiles.map((profile, index) => {
                return clientProfiles.find(
                  (c) => c.status === "Accepted" && c.id === profile.id
                ) ? (
                  <div key={index} className="col-span-12 md:col-span-3">
                    {" "}
                    <Profile
                      profile={profile}
                      justView={!showSignup}
                      updateProfileStatus={updateProfileStatus}
                      showNewModal={() => {
                        setshowNewModal(true);
                      }}
                      showModal={() => {
                        setshowModal(true);
                      }}
                      setProfileid={(e) => setProfileId(e)}
                      setValue={(e) => setValue(e)}
                      proccessed={true}
                    />{" "}
                  </div>
                ) : (
                  <div key={index} className="hidden"></div>
                );
              })}
          </div>
        </TabPanel>

        <TabPanel value="4">
          <div className="col-span-12 grid grid-cols-12 gap-3 px-5 md:px-10 pt-10">
            {profiles.length > 0 &&
              profiles.map((profile, index) => {
                return clientProfiles.find(
                  (c) => c.status === "Rejected" && c.id === profile.id
                ) ? (
                  <div key={index} className="col-span-12 md:col-span-3">
                    {" "}
                    <Profile
                      profile={profile}
                      justView={!showSignup}
                      updateProfileStatus={updateProfileStatus}
                      showNewModal={() => {
                        setshowNewModal(true);
                      }}
                      showModal={() => {
                        setshowModal(true);
                      }}
                      setProfileid={(e) => setProfileId(e)}
                      setValue={(e) => setValue(e)}
                      proccessed={true}
                    />{" "}
                  </div>
                ) : (
                  <div key={index} className="hidden"></div>
                );
              })}
          </div>
        </TabPanel>
      </TabContext>
    </div>
  );
}
export default Client;
